module.exports = __webpack_public_path__ + "static/img/20230731.4ad0c60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/20230731.jpg
// module id = jtCf
// module chunks = 100